module.exports = __webpack_public_path__ + "static/images/calendar-confirmed.1905e63f6aba31ef8c737306744aaa86.svg";